"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var Entity_1 = require("../../Core/Entity");
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var ChatMessage_consts_1 = require("../ChatMessage.consts");
var ChatMessage = /** @class */ (function (_super) {
    __extends(ChatMessage, _super);
    function ChatMessage(session) {
        var _this = _super.call(this, { session: session, entityName: 'chat_messages', routes: [Entity_1.BaseRoutes.Create, Entity_1.BaseRoutes.GetAll] }) || this;
        _this.mapByChatConversations = new Map();
        _this.onChatMessagesUpdateEvent = lodash_1.noop;
        _this.onChatMessagesUpdate = function (fn) {
            _this.onChatMessagesUpdateEvent = fn;
        };
        _this.store.state$.subscribe(function (state) {
            (0, rxjs_1.from)(Array.from(state.values()))
                .pipe((0, operators_1.groupBy)(function (chat) { return chat.chat_conversation_id; }, function (chat) { return chat; }), (0, operators_1.mergeMap)(function (group) {
                return (0, rxjs_1.zip)((0, rxjs_1.of)(group.key), group.pipe((0, operators_1.toArray)()));
            }))
                .subscribe(function (_a) {
                var _b = __read(_a, 2), chatId = _b[0], chatMessages = _b[1];
                _this.mapByChatConversations.set(chatId, (0, lodash_1.sortBy)(chatMessages, function (message) { return new Date(message.server_timestamp); }));
                _this.onChatMessagesUpdateEvent(_this.mapByChatConversations);
            });
        });
        _this.realTime.on('conversation message created', function (event) { return _this.store.addToStore(event.message); });
        return _this;
    }
    ChatMessage.prototype.getChatMessages = function (id) {
        return this.mapByChatConversations.get(id) || [];
    };
    ChatMessage.prototype.fetchMessages = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchAllAndStore({
                        chat_conversation_id: request.id,
                        before: request.before,
                        after: request.after,
                        page: request.page,
                        items: request.items
                    }, ChatMessage_consts_1.multipleExtractor)];
            });
        });
    };
    ChatMessage.prototype.createMessages = function (requests) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.bulkCreate({ messages: requests }, ChatMessage_consts_1.multipleExtractor)];
            });
        });
    };
    return ChatMessage;
}(StoreEntity_1.default));
exports.default = ChatMessage;
//# sourceMappingURL=ChatMessage.js.map